<template>
  <div class="visitor-result">
    <div class="header">
      <h1 class="header-title">访客自助登记</h1>
      <p class="header-subtitle">请如实填写，提交后将通知被访人审批</p>
    </div>

    <div class="result-body">
      <div class="result-card">
        <div class="icon-wrap" :class="{ 'icon-wrap--danger': isReject }">
          <van-icon :name="statusIcon" class="status-icon-inner" />
        </div>
        <h2 class="title">{{ pageTitle }}</h2>
        <p class="desc">{{ pageDesc }}</p>

        <div v-if="reservationNo" class="order-box">
          <div class="order-label">预约单号</div>
          <div class="order-value">{{ reservationNo }}</div>
        </div>

        <p class="footer-tip">{{ footerTip }}</p>

        <van-button type="info" block class="btn-continue" @click="onContinueRegister">
          继续登记
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VisitorSubmitResult',
  data () {
    return {
      sid: '',
      reservationNo: '',
      auditStatus: 0
    }
  },
  computed: {
    isReject () {
      return this.auditStatus === 4 || this.auditStatus === 5
    },
    statusIcon () {
      if (this.isReject) return 'close-circle'
      return 'checked'
    },
    pageTitle () {
      if (this.isReject) return '提交未通过'
      return '提交成功'
    },
    pageDesc () {
      if (this.auditStatus === 1) {
        return '您的访客预约申请已提交，系统已通知审批人。'
      }
      if (this.auditStatus === 2 || this.auditStatus === 3) {
        return '您的访客预约申请已处理，可按预约时间到访。'
      }
      if (this.isReject) {
        return '您的访客预约申请未通过审核，请联系被访人确认后重新提交。'
      }
      return '您的访客预约申请已提交，系统已通知审批人。'
    },
    footerTip () {
      if (this.isReject) {
        return '如有疑问，请联系被访人或现场工作人员。'
      }
      if (this.auditStatus === 2 || this.auditStatus === 3) {
        return '请按预约时间到访，并留意现场指引。'
      }
      return '请等待审核结果。审核通过后，您将收到短信通知，请留意消息。'
    }
  },
  created () {
    const q = (this.$route && this.$route.query) ? this.$route.query : {}
    this.sid = q.sid ? String(q.sid) : ''
    this.reservationNo = q.reservation_no ? String(q.reservation_no) : ''
    const status = q.audit_status ? Number(q.audit_status) : 0
    this.auditStatus = Number.isNaN(status) ? 0 : status
  },
  methods: {
    onContinueRegister () {
      this.$router.replace({
        path: '/visitor/register',
        query: this.sid ? { sid: this.sid } : {}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.visitor-result {
  min-height: 100vh;
  background: #f5f7fa;
  padding-bottom: calc(24px + env(safe-area-inset-bottom, 0));
}

.header {
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  color: #fff;
  padding: 16px 20px;
  padding-top: calc(16px + env(safe-area-inset-top, 0));
  text-align: center;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.25);
}

.header-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.header-subtitle {
  font-size: 13px;
  opacity: 0.95;
  margin: 4px 0 0 0;
}

.result-body {
  padding: 16px;
  max-width: 480px;
  margin: 0 auto;
}

.result-card {
  background: #fff;
  border-radius: 12px;
  padding: 28px 20px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  text-align: center;
}

.icon-wrap {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background: #e8f8ef;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrap--danger {
  background: #fef0f0;
}

.status-icon-inner {
  font-size: 36px;
  color: #07c160;
}

.icon-wrap--danger .status-icon-inner {
  color: #ee0a24;
}

.title {
  margin: 0 0 10px;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.desc {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #606266;
}

.order-box {
  margin: 20px 0 0;
  padding: 14px 12px;
  border-radius: 8px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  text-align: left;
}

.order-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
}

.order-value {
  font-size: 17px;
  font-weight: 600;
  color: #303133;
  font-family: ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, monospace;
  letter-spacing: 0.02em;
  word-break: break-all;
}

.footer-tip {
  margin: 16px 0 0;
  font-size: 12px;
  line-height: 1.6;
  color: #909399;
  text-align: left;
}

.btn-continue {
  margin-top: 20px;
  height: 48px;
  font-size: 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  border: none;
}
</style>
